// extracted by mini-css-extract-plugin
export default {"container":"CountryTable_container__UT4BF","wrapperTable":"CountryTable_wrapperTable__41XkM","emptyTable":"CountryTable_emptyTable__CxxqO"};